// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5 6.4998V17.4998L1 17.5L1 6.5L5 6.4998Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 18.2099L15.0004 22.7095L15.0004 1.29004L7 5.7896V18.2099Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.0004 10.5857L17.8791 8.46436L16.4648 9.87857L18.5862 11.9999L16.4648 14.1212L17.8791 15.5354L20.0004 13.4141L22.1217 15.5354L23.5359 14.1212L21.4146 11.9999L23.5359 9.87857L22.1217 8.46436L20.0004 10.5857Z"}}]};

const SoundMute1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sound-mute-1-filled',
    ref,
    icon: element,
  },
));

SoundMute1FilledIcon.displayName = 'SoundMute1FilledIcon';

export default SoundMute1FilledIcon;
